export function getDiffDay(date: string): number {
  const currentDate = new Date(Date.now());
  const newDate = new Date(date);
  const timeDifference: number = newDate.getTime() - currentDate.getTime();

  // Conversion en nombre de jours
  const daysDifference: number = timeDifference / (1000 * 60 * 60 * 24);

  return Math.ceil(daysDifference);
}

export function dateIsAfterNow(date: string): boolean {
  const currentDate = new Date(Date.now());
  const newDate = new Date(date);
  return currentDate > newDate;
}
